import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/mfa-management`;

export const getAllMfaManagementUsers = async () => {
  const targetUrl = `${baseRoute}/users`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getMfaManagementUserById = async userId => {
  const targetUrl = `${baseRoute}/users/${userId}`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const putMfaManagementUser = async user => {
  const targetUrl = `${baseRoute}/users/${user.userId}`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'PUT',
    headers,
    body: JSON.stringify(user),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const updateMfaTwoFactor = async (userId, twoFactorEnabled) => {
  const targetUrl = `${baseRoute}/users/${userId}/enable-mfa`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ twoFactorEnabled }),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const resetUserMfa = async userId => {
  const targetUrl = `${baseRoute}/users/${userId}/reset-mfa`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'POST',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const bulkUpdateMfaUsers = async (userIds, twoFactorEnabled) => {
  const targetUrl = `${baseRoute}/users/bulk-update-mfa`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ userIds, twoFactorEnabled }),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const removeTrustedDevice = async (userId, deviceId) => {
  const targetUrl = `${baseRoute}/trusted-devices/${userId}/remove/${deviceId}`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'DELETE',
    headers,
  });
  
  if (!response.ok) {
    return Promise.reject(response);
  }
  
  // Try to parse JSON, but don't fail if there's no body
  try {
    return await response.json();
  } catch {
    return { success: true }; // Return success if no JSON body
  }
};

export const getTrustedDevices = async (userId) => {
  const targetUrl = `${baseRoute}/trusted-devices/${userId}`;
  const headers = getHeaders();
  const response = await fetch(targetUrl, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
